/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';

/**
 * 
 * @export
 * @interface GetAttributesBucketName200Response
 */
export interface GetAttributesBucketName200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetAttributesBucketName200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetAttributesBucketName200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * Clear-text person attributes as key-value pairs. Attribute names (keys) may be at most 70 bytes long. Attribute values must be JSON-serializable and are limited to 64KiB.
     * @type {{ [key: string]: any; }}
     * @memberof GetAttributesBucketName200Response
     */
    result?: { [key: string]: any; };
}

/**
 * Check if a given object implements the GetAttributesBucketName200Response interface.
 */
export function instanceOfGetAttributesBucketName200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAttributesBucketName200ResponseFromJSON(json: any): GetAttributesBucketName200Response {
    return GetAttributesBucketName200ResponseFromJSONTyped(json, false);
}

export function GetAttributesBucketName200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttributesBucketName200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function GetAttributesBucketName200ResponseToJSON(value?: GetAttributesBucketName200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': value.result,
    };
}

